import request from '@/api/request'

export function apiConfigurationGetApiConfig() {
  return request({
    url: '/configuration/getApiConfig',
    method: 'get',
  })
}

export function apiConfigurationUpdateApiConfig(data) {
  return request({
    url: '/configuration/updateApiConfig',
    method: 'post',
    data,
  })
}

